module.exports = __webpack_public_path__ + "media/images/shared/icon-safesport-5f36792473cdd1d287d952bdd4ce3657.png";